module.exports = __webpack_public_path__ + "img/horizontal_3_2_5012.b31ecade.png";